<template>
  <div class="public-content order">
    <div class="breadcrumb">SKU组列表</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="100px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="SKU组ID:">
              <el-input v-model="formInline.skuGroupId" clearable placeholder="请输入SKU组ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="SKU组名称:">
              <el-input v-model="formInline.skuGroupName" placeholder="请输入SKU组名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称:">
              <el-input v-model="formInline.spuName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-permission="'pms:admin:sale:false'">
            <el-form-item label="上架状态:">
              <el-select v-model="formInline.onSale" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="已上架" :value="1"></el-option>
                <el-option label="已下架" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="$store.state.user.userType !== 'SALESMAN'">
            <el-form-item label="审核状态:">
              <el-select v-model="formInline.auditStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <el-option label="待审核" value="WAIT_AUDIT"></el-option>
                <el-option label="已审核" value="AUDIT_SUCCESS"></el-option>
                <el-option label="审核拒绝" value="AUDIT_FAIL"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="queryInfo.pageNum = 1, getSkuList()" round>查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column label="SKU组ID" prop="id"></el-table-column>
          <el-table-column prop="skuGroupName" label="SKU组名称"></el-table-column>
          <el-table-column label="SKU组图片">
            <template v-slot="scope">
              <img :src="scope.row.skuGroupImage">
            </template>
          </el-table-column>
          <el-table-column prop="dictSet" label="属性组合"></el-table-column>
          <el-table-column prop="spuName" label="产品名称"></el-table-column>
          <el-table-column label="上下架状态">
            <template slot-scope="scope">
              <div v-if="$hasPermission('pms:admin:sku:group:sale')">
                <span v-show="scope.row.onSale" @click="downDialog = true, downFrameId = scope.row.id" class="color-blue">已上架</span>
                <span v-show="!scope.row.onSale && scope.row.auditStatus !== 'WAIT_AUDIT'" class="color-blue" @click="upDialog = true, upFrameId = scope.row.id">已下架</span>
              </div>
              <div v-else>
                <span v-show="scope.row.onSale">已上架</span>
                <span v-show="!scope.row.onSale && scope.row.auditStatus === 'WAIT_AUDIT'">已下架</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="scope">
              <span v-if="scope.row.auditStatus === 'WAIT_AUDIT'">待审核</span>
              <span v-if="scope.row.auditStatus === 'AUDIT_SUCCESS'">已审核</span>
              <span v-if="scope.row.auditStatus === 'AUDIT_FAIL'">审核拒绝</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建日期"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <span class="color-blue" @click="to(scope.row, '查看')">查看<br></span>
              <span class="color-blue" @click="to(scope.row, '编辑')" v-permission="'pms:admin:sku:group:update'">编辑<br></span>
              <span class="color-blue" v-show="scope.row.auditStatus === 'WAIT_AUDIT'" @click="to(scope.row, '审核')" v-permission="'pms:admin:sku:group:audit'">审核<br></span>
              <span @click="toLog(scope.row)" v-permission="'pms:admin:skugroup:log'" class="color-blue">日志<br></span>
              <span class="color-blue" v-permission="'pms:admin:sku:group:delete'" v-if="!scope.row.onSale" @click="deleteItemId = scope.row.id, deleteDialog = true">删除<br></span>
              <span v-show="scope.row.auditStatus === 'AUDIT_SUCCESS'" v-permission="'pms:admin:special:add'" @click="specialPrice(scope.row)" class="color-blue">申请特殊价格</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <!-- 删除 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="deleteDialog" width="30%">
      <p>是否确认删除？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSkuGroup">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下架 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="downDialog" width="30%">
      <h2>是否下架</h2>
      <p>是否确认下架？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downDialog = false">取 消</el-button>
        <el-button type="primary" @click="downFrame">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上架 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="upDialog" width="30%">
      <h2>是否上架</h2>
      <p>是否确认上架？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upDialog = false">取 消</el-button>
        <el-button type="primary" @click="upFrame">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="已关联套系SKU组" :visible.sync="AssociateSeriesDialog" width="500px">
      <el-table :data="AssociateSeriesList" border style="width: 100%">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="skuGroupName" label="SKU组名称"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="AssociateSeriesDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { skuGroupList, skuGroupListAssociateSeries, categoryList, skuGroupSale, skuGroupDelete } from '@/api/pms'
export default {
  name: 'order',
  components: {
    VPagination
  },
  inject: ['reload'],
  data () {
    return {
      AssociateSeriesDialog: false,
      AssociateSeriesList: [],
      deleteItemId: '',
      deleteDialog: false,
      upFrameId: '',
      upDialog: false,
      downDialog: false,
      formInline: {
        auditStatus: this.$store.state.userType === 'SALESMAN' ? 'AUDIT_SUCCESS' : null,
        onSale: '',
        skuGroupId: null,
        skuGroupName: '',
        spuName: ''
      },
      categoryList: [],
      tableData: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  destroyed () {
    // 销毁
    // console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
    }
    // if (this.$hasPermission('pms:admin:sale:false')) {
    //   this.formInline.onSale = 1
    // } else {
    //   this.formInline.onSale = ''
    // }
    if (this.$route.query.auditStatus === 'WAIT_AUDIT') {
      this.formInline.auditStatus = 'WAIT_AUDIT'
    }
    // if (this.$route.query.auditStatus === 'WAIT_AUDIT') {
    //     this.formInline.auditStatus = 'WAIT_AUDIT'
    // }
    this.getSkuList(this.queryInfo)
    // 获取sku组状态
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     if (vm.$notPerm('pms:admin:sale:false')) {
  //       vm.formInline.onSale = 1
  //     }
  //     if (to.query.auditStatus === 'WAIT_AUDIT') {
  //       vm.formInline.auditStatus = 'WAIT_AUDIT'
  //     }
  //     vm.getSkuList(vm.queryInfo)
  //   })
  // },
  methods: {
    deleteSkuGroup () {
      skuGroupDelete(this.deleteItemId).then(res => {
        if (res.data.success) {
          this.getSkuList(this.queryInfo)
          this.$message.success('删除成功')
          this.deleteDialog = false
        }
      })
    },
    toLog (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/skulog', query: { id: row.id } })
    },
    specialPrice (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      this.$router.push({ path: '/applysprice', query: { id: row.id, spuProperty: row.spuProperty, isSeries: row.isSeries } })
    },
    to (row, type) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      console.log(row, 'row')
      if (type === '查看') {
        this.$router.push({
          path: row.isSeries ? '/EditSysSkuGroupDetail' : '/Editskudetails',
          query: {
            spuProperty: row.spuProperty,
            id: row.id,
            auditStatus: row.auditStatus,
            spuId: this.$route.query.id,
            onSale: row.onSale,
            type: 'check',
            startupsSpu: row.topCategoryId == 10 ? 'true' : 'false'
          }
        })
      } else if (type === '编辑') {
        this.$router.push({
          path: row.isSeries ? '/CheckSysSkuGroupDetail' : '/checkskudetails',
          query: {
            spuProperty: row.spuProperty,
            id: row.id,
            auditStatus: row.auditStatus,
            spuId: this.$route.query.id,
            onSale: row.onSale,
            categoryId: row.topCategoryId,
            isDiy: row.isDiy,
            isHavePromoCode: row.isHavePromoCode,
            startupsSpu: row.topCategoryId == 10 ? 'true' : 'false'
          }
        })
      } else if (type === '审核') {
        this.$router.push({
          path: row.isSeries ? '/EditSysSkuGroupDetail' : '/Editskudetails',
          query: {
            spuProperty: row.spuProperty,
            id: row.id,
            auditStatus: row.auditStatus,
            spuId: this.$route.query.id,
            onSale: row.onSale,
            type: 'audit',
            startupsSpu: row.topCategoryId == 10 ? 'true' : 'false'
          }
        })
      }
    },
    // 上架
    upFrame () {
      skuGroupSale({ skuGroupId: this.upFrameId, status: true }).then(res => {
        if (res.data.success) {
          this.$message.success('已上架')
          this.getSkuList()
          this.upDialog = false
        }
      })
    },
    // 下架
    downFrame () {
      skuGroupSale({ skuGroupId: this.downFrameId, status: false }).then(res => {
        if (res.data.success) {
          this.$message.success('已下架')
          this.getSkuList()
          this.downDialog = false
        } else if (res.data.message === 'pms.sku.has.associate') {
          skuGroupListAssociateSeries(this.downFrameId).then(res => {
            if (res.data.success) {
              this.AssociateSeriesList = res.data.data
              this.downDialog = false
              this.AssociateSeriesDialog = true
            }
          })
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    getSkuList (val) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      }
      skuGroupList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, skuVo: this.formInline }).then((res) => {
        if (res.data.success) {
          if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
            this.queryInfo.pageNum--
            this.getSkuList(this.queryInfo)
          }
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        } else {
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.getSkuList(this.queryInfo)
    },
    getPage () {
      this.$router.push('./skucontactplatform')
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
